<button
  [ngClass]="[type, size, disabled ? 'btn_disabled' : '']"
  [disabled]="disabled"
  (click)="onClick()"
>
  @if (leftIcon) {
    <i
      class="pi icon left-icon"
      [ngClass]="isActive && leftIconActive ? leftIconActive : leftIcon"
    ></i>
  }
  {{ label }}
  @if (rightIcon) {
    <i
      class="pi icon right-icon"
      [ngClass]="isActive && rightIconActive ? rightIconActive : rightIcon"
    ></i>
  }
</button>
